import { useEffect, useState } from "react";

export default function useMediaQuery(query: string) {
	const [matches, setMatches] = useState(false);

	useEffect(() => {
		setMatches(window.innerWidth < 1200);
	}, []);

	useEffect(() => {
		const matchQueryList = window.matchMedia(query);

		function handleChange(e: any) {
			setMatches(e.matches);
		}

		matchQueryList.addEventListener("change", handleChange);

		return () => {
			matchQueryList.removeEventListener("change", handleChange);
		};
	}, [query]);

	return matches;
}
